<template>
  <div style="width:100%">
    <v-subheader v-if="!mbglSupported">
      Votre navigateur n'est pas compatible avec cette application.
      Une version de cette application compatible avec un plus grand nombre de navigateurs sera bientôt publiée.
    </v-subheader>
    <template v-else-if="dataset">
      <v-navigation-drawer
        v-show="displayPanel"
        :mini-variant="!filtersPanel"
        :mini-variant-width="40"
        :width="290"
        permanent
        absolute
        hide-overlay
        style="overflow: visible;"
        class="px-3"
      >
        <div style="height:100vh;overflow-y:auto">
          <v-btn
            :title="(filtersPanel ? 'Fermer' : 'Ouvrir') + ' le panneau de filtres'"
            fab
            small
            depressed
            style="position:absolute;right:-20px;top:12px;z-index:10"
            @click.native="filtersPanel = !filtersPanel"
          >
            <v-icon>mdi-chevron-{{ filtersPanel ? 'left' : 'right' }}</v-icon>
          </v-btn>
          <div style="width:252px">
            <address-search
              v-if="!config.hideSearchBar"
              class="mb-4"
            />
            <filters
              v-show="filtersPanel"
            />
          </div>
        </div>
      </v-navigation-drawer>
      <mbgl-map
        ref="map"
        :style="'width:100%;height:' + windowHeight + 'px'"
      />
      <v-card
        v-if="legend && config.colors.type !== 'single'"
        style="bottom:24px;"
        class="legend"
      >
        <v-col class="text-center">
          <h4 :class="`subheader ${ maxLegendItemLength < legendTitle.length ? 'condensed-legend-title' : ''}`">
            {{ legendTitle }}
          </h4>
        </v-col>
        <ul>
          <li
            v-for="(item, i) in legend"
            :key="i"
          >
            <span
              :style="`background-color:${item.color}`"
              class="color-box"
            />
            {{ (config.colors.enumOptions ? formatField({[config.colors.enumOptions.field]: item.value}, fields[config.colors.enumOptions.field]) : item.value) + (config.unit ? ' ' + config.unit : '') }}
          </li>
          <li
            v-if="config.defaultValuesInLegend"
          >
            <span
              :style="`background-color:${config.colors.default}`"
              class="color-box"
            />
            Non renseigné
          </li>
        </ul>
      </v-card>
    </template>
  </div>
</template>

<script>
import MbglMap from './MbglMap.vue'
import AddressSearch from './Address.vue'
import Filters from './Filters.vue'
import { mapState, mapGetters } from 'vuex'
import { formatField } from '@data-fair/components-app/format/fields'
import colors from '../assets/colors'
const mbglSupported = require('mapbox-gl-supported')()

export default {
  components: { MbglMap, Filters, AddressSearch },
  data () {
    return {
      mapHeight: 0,
      mbglSupported,
      filtersPanel: false
    }
  },
  computed: {
    ...mapState(['application', 'dataset', 'quantiles', 'colorMetrics']),
    ...mapGetters(['datasetUrl', 'config', 'fields']),
    colorField () {
      if (this.config.colors?.type === 'enum' && this.config.colors.enumOptions.field) return this.config.colors.enumOptions.field
      else if (this.config.colors?.type === 'range' && this.config.colors.rangeOptions.field) return this.config.colors.rangeOptions.field
      return null
    },
    legend () {
      if (!this.config.colors) return
      if (this.config.colors.rangeOptions?.scheme.computed && !this.colorMetrics) return
      return colors(this.config.colors, this.colorMetrics?.min, this.colorMetrics?.max, this.quantiles)
    },
    legendTitle () {
      if (this.colorField) {
        const field = this.dataset.schema.find(f => f.key === this.colorField)
        return field && (field.title || field['x-originalName'] || field.key)
      }
      return ''
    },
    maxLegendItemLength () {
      return Math.max(...this.colors(this.config.colors, this.colorMetrics?.min, this.colorMetrics?.max, this.quantiles).map(c => (this.config.colors.enumOptions ? formatField({ [this.config.colors.enumOptions.field]: c.value }, this.fields[this.config.colors.enumOptions.field]) : c.value).length))
    },
    displayPanel () {
      return this.config.dynamicFilters?.length || !this.config.hideSearchBar || !this.config.hideTextFilter
    }
  },
  async mounted () {
    this.filtersPanel = this.config.filtersPanelOpen && this.$vuetify.breakpoint.mdAndUp
  },
  methods: {
    colors,
    formatField
  }
}
</script>

<style>
.legend {
  position: absolute;
  background-color: white;
  padding: 4px;
  max-width:35%;
  right:4px;
}

.condensed-legend-title {
  min-width: 140px;
  width: min-content;
  width: -moz-min-content;
  width: -webkit-min-content;
}

ul {
  list-style-type: none;
  padding-left: 6px!important;
  margin-top: 0;
  margin-bottom: 2px;
}

.color-box {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  position: relative;
  top: 5px;
  border-style: solid;
  border-width: 1px;
}
</style>
